import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import type { Automation, AutomationRun, CreateAutomationRequest, CreateAutomationResponse, UpdateAutomationRequest } from './Types';

export class AIRequester {
  private requester: Requester;

  private readonly baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = '/api/v1';
  }

  public getThreadFiles = async (threadId: string) => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/threads/${threadId}/files`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);

    return data;
  };

  public getFiles = async () => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/files`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);

    return data;
  };

  public deleteAutomation = async (automationId: string): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/automations/${automationId}`,
      method: HttpMethod.DELETE,
    };
    await this.requester.request(requestData);
  };

  public getAutomationRuns = async (automationId: string): Promise<AutomationRun[]> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/automations/${automationId}/runs`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);
    return data as AutomationRun[];
  };

  public getAutomations = async (): Promise<Automation[]> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/automations`,
      method: HttpMethod.GET,
    };
    const { data } = await this.requester.request(requestData);
    return data as Automation[];
  };

  public createAutomation = async (payload: CreateAutomationRequest): Promise<CreateAutomationResponse> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/automations`,
      method: HttpMethod.POST,
      body: JSON.stringify(payload),
    };
    const { data } = await this.requester.request(requestData);
    return data as CreateAutomationResponse;
  };

  public updateAutomation = async (automationId: string, payload: UpdateAutomationRequest): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/automations/${automationId}`,
      method: HttpMethod.PUT,
      body: JSON.stringify(payload),
    };
    await this.requester.request(requestData);
  };
}

export default AIRequester;
